import type { BulkBiddingVehiclesResult } from 'Pages/api/bulk-bidding/vehicles/request';
import { resolveParams } from 'Services/services.helpers';

import axios from '../axios';

interface Query {
	enquiryIds?: string | string[];
}

type GetBulkBiddingVehiclesApiCall = (query: Query) => BulkBiddingVehiclesResult;

export const getVehiclesForBulkBidding: GetBulkBiddingVehiclesApiCall = async (query) => {
	const res = await axios.get(`/api/bulk-bidding/vehicles${resolveParams(query)}`);

	return res.data;
};
